export default "__VITE_ASSET__DGCfjfRF__"